import { createApp } from 'vue'
import App from './App.vue'
import './styles/global.scss'

createApp(App).mount('#app')
